const resultsOpts = {
    selector: '#t-selector a',
    name: 't',
    all: false,
};

const homeOpts = {
    selector: '#type-selector a',
    name: 'fq',
    all: 'everything',
};

const selectOpts = {
    selector: '#type-selector a',
    name: 'fq',
    all: 'everything',
};

export {
    resultsOpts,
    homeOpts,
    selectOpts,
};
